import "lazysizes/plugins/object-fit/ls.object-fit";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import "lazysizes/plugins/rias/ls.rias";
import "lazysizes/plugins/bgset/ls.bgset";
import "lazysizes";
import "lazysizes/plugins/respimg/ls.respimg";

import "../../styles/theme.scss";
import "../../styles/theme.scss.liquid";

import $ from "jquery";
import { pageLinkFocus } from "@shopify/theme-a11y";
import { cookiesEnabled } from "@shopify/theme-cart";
import { wrapTable, wrapIframe } from "@shopify/theme-rte";

import Redirect from "../sections/redirect";
import MegaMenu from "../sections/mega_menu";
import Magazine from "../sections/magazine";
import PackagingCarousel from "../sections/packaging_carousel";
import Cookies from "../sections/cookies";
import Breakroom from "../sections/breakroom";

window.slate = window.slate || {};
window.theme = window.theme || {};

$(document).ready(() => {
  // Common a11y fixes
  if (window.location.hash !== "#") {
    pageLinkFocus($(window.location.hash));
  }

  $(".in-page-link").on("click", (evt) => {
    pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  const tableSelectors = ".rte table";

  wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: "rte__table-wrapper",
  });

  // Target iframes to make them responsive
  const iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: "rte__video-wrapper",
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace(
      "supports-no-cookies",
      "supports-cookies"
    );
  }

  // Initialize Redirect Modal
  Redirect();

  // Initialize Mega-Menu
  MegaMenu();

  // Initialize cookie banner
  new Cookies();

  // Initialize the breakroom
  new Breakroom();

  // Mobile Nav
  $(".mobile-nav-trigger").click(function() {
    $(".mobile-nav").toggleClass("active");
  });

  // Initialize Magazine
  Magazine();

  // Initialize Packaging Carousel
  PackagingCarousel();

  // Increase/decrease product quantity
  $("#quantity-inc").click(function() {
    $("#Quantity").val(function(i, oldval) {
      if ($("#Quantity").val() === $("#Quantity").attr("max")) {
        return $("#Quantity").attr("max");
      }
      return ++oldval;
    });
    $("#quantity-disp").html($("#Quantity").val());
  });

  $("#quantity-dec").click(function() {
    $("#Quantity").val(function(i, oldval) {
      if (oldval <= 1) {
        return 1;
      } else {
        return --oldval;
      }
    });
    $("#quantity-disp").html($("#Quantity").val());
  });

  // Currency selector
  $(".shopify-currency-form__select").on("change", function() {
    $(this)
      .parents("form")
      .submit();
  });
});
